import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { HiPhone, HiMail } from 'react-icons/hi'
import { FaVk } from 'react-icons/fa'
import { useLocalizedLink } from '../../hooks/useLocalizedLink'
import './Footer.css'

function Footer() {
  const { t, i18n } = useTranslation()
  const getLocalizedLink = useLocalizedLink()
  const currentYear = new Date().getFullYear()
  
  // Определяем ссылку ВКонтакте в зависимости от языка
  const vkUrl = i18n.language === 'ru' 
    ? 'https://vk.com/sumaunion' 
    : 'https://vk.com/sumaorg'

  return (
    <footer className="footer">
      <div className="footer-divider"></div>
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <Link to={getLocalizedLink('/')} className="footer-logo">
              <img src="/logo-isuma.png" alt="SUMA International" className="footer-logo-image" />
            </Link>
            <p className="footer-description">
              {t('footer.description', 'International School Union of Martial Arts')}
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">{t('common.about')}</h3>
            <nav className="footer-nav">
              <Link to={getLocalizedLink('/about')}>{t('common.about')}</Link>
              <Link to={getLocalizedLink('/founder')}>{t('common.founder')}</Link>
              <Link to={getLocalizedLink('/president')}>{t('common.president')}</Link>
              <Link to={getLocalizedLink('/presidium')}>{t('common.presidium')}</Link>
              <Link to={getLocalizedLink('/representatives')}>{t('common.representatives')}</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">{t('common.martialArts')}</h3>
            <nav className="footer-nav">
              <Link to={getLocalizedLink('/martial-arts')}>{t('common.martialArts')}</Link>
              <Link to={getLocalizedLink('/certifications')}>{t('common.certifications')}</Link>
              <Link to={getLocalizedLink('/black-belts')}>{t('common.blackBelts')}</Link>
              <Link to={getLocalizedLink('/colored-belts')}>{t('common.coloredBelts')}</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">{t('common.contact')}</h3>
            <div className="footer-contact">
              <a href="tel:+73432269909" className="contact-item">
                <HiPhone className="contact-icon" />
                <span>+7 (343) 226-99-09</span>
              </a>
              <a href="mailto:sumaunion@yandex.ru" className="contact-item">
                <HiMail className="contact-icon" />
                <span>sumaunion@yandex.ru</span>
              </a>
              <a 
                href={vkUrl} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="contact-item"
                aria-label={t('footer.vkontakte', 'VKontakte')}
              >
                <FaVk className="contact-icon" />
                <span>{t('footer.vkontakte', 'VKontakte')}</span>
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            {t('footer.copyright', '© 2004-{{year}} SUMA International. All rights reserved.', { year: currentYear })}
          </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer

